export const demoTourTasks = [
  {
    taskKey: 'create_legal_entity',
    title: 'Creating legal entities and assigning employees',
  },
  {
    taskKey: 'add_employee',
    title: 'Adding employees',
  },
]
